import React from "react";
import "./Testimonies.css"; // Import the CSS file for styling
import { useLanguage } from "../LanguageContext";

function Testimonies() {
  const { language } = useLanguage();

  return (
    <div className="testimonies-container">
      <h2 className="section-title testimonies-title">
        {language === 'ar' ? 'شهادات' : language === 'fr' ? 'TÉMOIGNAGES' : 'TESTIMONIES'}
      </h2>
      <div className="testimonies-grid">
        <div className="testimony-card">
          <div className="quote-icon">“</div>
          <p>
            {language === 'ar' ? 
              `"كواليا ليس الكتاب الأول لهاجر أوحسين باللغة العربية، فهي عاشقة للكتابة الأدبية رغم أنها قادمة من تخصص بعيد عن الأدب، ومن تكوين أكاديمي بلغة غير العربية. في تصنيف كتابها كواليا، اختارت هاجر "نصوص" عن وعي، حيث تقارب من خلاله لحظات عابرة أو ممتدة، بتأمل يمزج بين الفلسفي والأدبي، لتؤكد بذلك انتماءها لهذا النوع من الكتابة."` 
              : language === 'fr' ?
              `"Qualia n'est pas le premier livre de Hajar Ouhsine en arabe. Elle est passionnée par l'écriture littéraire, bien qu'elle vienne d'une discipline éloignée de la littérature. Dans la classification de son livre Qualia, Hajar a consciemment choisi 'textes', abordant des moments éphémères ou prolongés, avec une contemplation qui mêle le philosophique et le littéraire."`
              :
              `"Qualia is not Hajar Ouhsine's first book in Arabic. She is passionate about literary writing. In classifying her book Qualia, Hajar consciously chose 'texts', approaching ephemeral or prolonged moments with a contemplation that mixes the philosophical and the literary."`
            }
          </p>
          <h4 className="author-name">- {language === 'ar' ? 'أحمد لمسيح' : 'Ahmed Lemsiyeh'}</h4>
        </div>

        <div className="testimony-card">
          <div className="quote-icon">“</div>
          <p>
            {language === 'ar' ? 
              `"يولد الإنسان ويكبر طفلاً، فمراهقاً فشاباً، ويصبح عجوزاً. في مسيرته هذه يختبر الحياة، مرها وحلوها. يطور الإنسان لكل تجربة مشاعر خاصة، مشاعر لا يمكن نقلها إلا بالتجربة. هذه المشاعر تنجح الكاتبة في نقلها بكل حب عبر الكتابة. ستجد نفسك بين دفتي الكتاب، أنا متأكد من ذلك. فقد وجدت نفسي في أكثر من صفحة، سعيداً، حزيناً، يائساً، حالماً..."`
              : language === 'fr' ?
              `"L'être humain naît et grandit en tant qu'enfant, adolescent, puis adulte. Dans ce parcours, il fait l'expérience de la vie, ses peines et ses joies. L'auteure réussit à transmettre ces émotions avec amour à travers son écriture. Vous vous retrouverez dans les pages de ce livre, j'en suis sûr. Je m'y suis retrouvé à plusieurs reprises."`
              :
              `"A person is born and grows up as a child, an adolescent, then an adult. In this journey, they experience life, its sorrows and its joys. The author succeeds in transmitting these emotions with love through her writing. You will find yourself in the pages of this book, I am sure of it."`
            }
          </p>
          <h4 className="author-name">- {language === 'ar' ? 'محمد همو' : 'Mohamed Hammou'}</h4>
        </div>

        <div className="testimony-card">
          <div className="quote-icon">“</div>
          <p>
            {language === 'ar' ? 
              `"كتاب مذهل لكاتبة تعرف كيف تخيط الكلمات لصوغ نصوص تبقى في الذاكرة. كتاب يترسخ في الوجدان. جمل مكتوبة بإحكام وبحكمة. كتاب يستحق أن يُقرأ عدة مرات ليعيش معه القارئ لحظات مضاعفة من المتعة التي يضيفها. كتاب ممتع، رفيع المستوى، من كاتبة شابة نتمنى أن نقرأ لها العديد من المؤلفات مستقبلاً. كاتبة تعرف بحق كيف تكتب كتابات لا تُنسى."`
              : language === 'fr' ?
              `"Un livre incroyable d'une auteure qui sait tisser les mots pour créer des textes inoubliables. Un livre qui s'ancre dans l'âme. Des phrases écrites avec soin et sagesse. Un livre agréable, de haut niveau, d'une jeune écrivaine dont nous espérons lire de nombreux ouvrages à l'avenir. Une écrivaine qui sait vraiment comment écrire des textes mémorables."`
              :
              `"An incredible book by an author who knows how to weave words to create unforgettable texts. A book that anchors itself in the soul. Sentences written with care and wisdom. A pleasant, high-level book by a young writer. A writer who truly knows how to write memorable texts."`
            }
          </p>
          <h4 className="author-name">- {language === 'ar' ? 'خالد موقدمين' : 'Khalid Moukaddemine'}</h4>
        </div>
      </div>
    </div>
  );
}

export default Testimonies;
